// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"258":"b564ac38","294":"d078c84d","453":"36c0b50e","656":"8de98eb5","765":"4c531803"}[chunkId] + ".chunk.js";
};